import * as Sentry from '@sentry/browser'

// Record consumed values, not the full server response or any targeting properties.
let evaluatedFlags: Record<string, boolean> = {}

export function recordFeatureFlag(flag: string, enabled: boolean): void {
  evaluatedFlags[flag] = enabled
  Sentry.setContext('feature_flags', { ...evaluatedFlags })
}

export function clearFeatureFlagContext(): void {
  evaluatedFlags = {}
  Sentry.setContext('feature_flags', null)
}
